module.exports = __webpack_public_path__ + "images/ef674c3ee0bcab4176ad15a6d61dfa13.svg";